import {
  SET_INVITATION_BY_ID, SET_QUESTIONNAIRE_PAGE,
  SET_TESTS,
  SET_TESTS_EN_CURSO
} from "../actions/sagaActions";

export default function(state = { invitations: {}, questionnaire_pages: {} }, action) {
  switch (action.type) {
    case SET_TESTS:
      return {
        ...state,
        tests: {
          ...state.tests,
          [action.payload.page]: action.payload.data
        }
      };
    case SET_TESTS_EN_CURSO:
      return {
        ...state,
        encurso: {
          ...state.encurso,
          [action.payload.page]: action.payload.data
        }
      };
    case SET_INVITATION_BY_ID:
      return {
        ...state,
        invitations: {
          ...state.invitations,
          [action.payload.id]: action.payload
        }
      };
    case SET_QUESTIONNAIRE_PAGE:
      let nextState = { ...state };
      nextState.questionnaire_pages = {
        ...nextState.questionnaire_pages,
        [action.payload.id]: action.payload
      };
      return nextState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/testsReducer.js